import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class AssignmentsService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get('v1/assignments').pipe(
      map((response: HttpResponse) => {
        return response.data;
      })
    );
  }
}
